export default __webpack_public_path__ + "static/media/check-circle-fill.7b3b9b21.svg";